import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/common.css";
import styles from "../assets/css/confidentiality-agreement.module.css";
import DocumentBody from "../components/DocumentBody";
import SignaturePad from "../components/SignaturePad";
import { confidentialityService } from "../services/confidentialityService";
import { registrationCheckService } from "../services/registrationCheckService";
import { documentService } from "../services/documentService";

function ConfidentialityAgreement() {
  const navigate = useNavigate();
  const padRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkRegistrationStatus = async () => {
      try {
        const { 
          hasMemberData, 
          hasRouteData, 
          hasPhotoData, 
          hasConfidentialityData 
        } = await registrationCheckService.checkRegistration();
        
        if (hasConfidentialityData) {
          navigate("/");
        } else if (!hasPhotoData) {
          navigate("/photo-permission");
        } else if (!hasRouteData) {
          navigate("/route-check");
        } else if (!hasMemberData) {
          navigate("/member-registration");
        }
      } catch (error) {
        console.error('登録状態確認エラー:', error);
      }
    };

    // 書面本文は管理者が改訂できるため、現行の公開版をAPIから取得する
    const fetchDocument = async () => {
      try {
        setDoc(await documentService.getCurrent('confidentiality'));
      } catch (error) {
        console.error("書面取得エラー:", error);
        setError("書面の取得に失敗しました。時間をおいて再度お試しください。");
      }
    };

    checkRegistrationStatus();
    fetchDocument();
  }, [navigate]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (padRef.current?.isEmpty()) {
      setError('署名を記入してください。');
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      await confidentialityService.saveConfidentialityAgreement({
        signatureData: padRef.current.toDataURL(),
        documentVersionId: doc?.versionId
      });

      navigate("/first-complete");
    } catch (err) {
      console.error('機密保持誓約保存エラー:', err);
      setError("保存に失敗しました。もう一度お試しください。");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div id="agreement-container" className={styles.container}>
      <div className="agreement-card">
        <h1 className={`${styles.heading} mb-4`}>秘密保持誓約書確認</h1>
        {doc && (
          <div className="text-end text-small text-muted mb-1">v{doc.version}</div>
        )}
        <DocumentBody body={doc?.body} className={`${styles.description} mb-4`} />

        <div className={`${styles.signatureArea} mb-4`}>
          <SignaturePad ref={padRef} className={`${styles.signatureCanvas} shadow rounded`} />
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <div className="d-grid mt-4">
          <button 
            type="button" 
            className="btn btn-primary btn-lg"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "送信中..." : "同意して送信"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfidentialityAgreement;
